import { ProfileGalleryImage } from '../../../../api/Providers/GalleryImages';

/**
 * Represents an "empty" image
 */
export type EmptyImage = {
  empty: true;
  id: number;
};

/**
 * Gets a value indicating whether or not the given image is "empty"
 */
export const isEmpty = (item: EmptyableImage): item is EmptyImage => (item as any).empty;

/**
 * An image record which may either be "empty" or a standard gallery image
 */
export type EmptyableImage = ProfileGalleryImage | EmptyImage;

/**
 * A row of images
 */
export type ImageRow = { key: string, images: Array<EmptyableImage> };
